import { motion } from 'framer-motion'
import type { ReactNode } from 'react'

import { useMotionPreference } from '@/hooks/useMotionPreference'
import { transition } from '@/lib/motion'

type PageTransitionProps = {
  children: ReactNode
}

export function PageTransition({ children }: PageTransitionProps) {
  const reduceMotion = useMotionPreference()

  if (reduceMotion) {
    return <>{children}</>
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8, transition: transition.pageExit }}
      transition={transition.pageEnter}
    >
      {children}
    </motion.div>
  )
}
